import type { AccessPolicy } from '@/access';
import type { userAtom } from '@/global-store';
import { isModuleRestricted } from '@/guards/routeAccess';
import type { ExtractAtomValue } from 'jotai/vanilla';

export type CurrentUser = ExtractAtomValue<typeof userAtom>;

export function allowedToShowItem(
  access: AccessPolicy,
  user: CurrentUser,
  path: string,
): boolean {
  for (const allowedItem of access.allowed) {
    switch (allowedItem) {
      case 'all':
        return true;
      case 'no-user':
        if (!user?.id) return true;
        break;
      case 'user':
        if (user) return true;
        break;
      case 'admin':
        if (user?.isAdmin) return true;
        break;
      case 'salesAdmin':
        if (user?.isAdmin || user?.isSalesAdmin) return true;
        break;
      case 'partner':
        if (user?.isAdmin || (user && 'isPartner' in user && user.isPartner)) {
          return true;
        }
        break;
      case 'restrict':
        return Boolean(
          user && !isModuleRestricted(user, path, access.allowedConfig),
        );
    }
  }

  return false;
}
